<template>
    <div>
        <!-- <AddEditPrescription :isNew="true" :isContract="isContract" /> -->
        <v-btn class="mt-5" color="primary" @click="addPresc" v-show="userPermissions.some(x => x === 'prescription_form')">{{ $t('Добавить') }}</v-btn>
        <v-data-table
            class="mt-5"
            :headers="headers"
            :items="PLT"
            :options.sync="prescriptionPagination"
            :server-items-length="PrescriptionListLength"
            :loading="PrescriptionLoading"
            :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [10, 15, 20, 25] }"
        >
            <template v-slot:item.is_formed="{ item }">
                <span> {{ item.is_formed ? $t('да') : $t('нет') }} </span>
            </template>
            <template v-slot:item.note="{ item }">
                <div class="d-flex align-center">
                    <span> {{ item.note }} </span>
                </div>
            </template>
            <template v-slot:item.record_id="{ item }">
                <div class="d-flex align-center justify-space-around">
                    <v-btn
                        v-show="item.status_code_name !== 'canceled' && item.status_code_name !== 'completed'"
                        icon
                        @click="openDeleteDialog(item)"
                        :title="$t('Аннулирование предписания')"
                        v-if="userPermissions.some(x => x === 'prescription_form')"
                        ><v-icon>mdi-delete-forever</v-icon></v-btn
                    >
                    <v-btn icon @click="openEdit(item.record_id)" :title="$t('Редактирование предписания')"><v-icon>edit</v-icon></v-btn>
                </div>
            </template>
            <template v-slot:item.issue_date="{ item }">
                <span> {{ item.issue_date | formatDate }} </span>
            </template>
            <template v-slot:item.status_name="{ item }">
                <span>{{ item.status_name }}</span>
                <v-btn
                    color="primary"
                    v-show="item.status_code_name === 'formed' || item.status_code_name === 'issued'"
                    @click="StatusChange(item)"
                    v-if="userPermissions.some(x => x === 'prescription_form')"
                    >{{ $t('Изменить') }}</v-btn
                >
            </template>
        </v-data-table>
        <v-dialog v-model="deleteDialog" eager max-width="350px">
            <LabeledCard :label="$t('Подтвердите аннулирование')">
                <div class="d-flex align-center justify-center mt-5 mb-5">
                    <span>
                        {{ $t('Аннулировать предписание?') }}
                    </span>
                </div>
                <div class="d-flex align-center justify-space-around mt-5 mb-5">
                    <v-btn outlined color="primary" @click="deleteDialog = false">{{ $t('нет') }}</v-btn>
                    <v-btn color="primary" @click="deletePresc">{{ $t('да') }}</v-btn>
                </div>
            </LabeledCard>
        </v-dialog>
        <v-dialog v-model="changeStatusDialog" eager max-width="300px">
            <LabeledCard :label="$t('Изменение статуса')">
                <div class="d-flex align-center justify-center mt-5 mb-5">
                    <span>
                        {{ $t('Изменить статус на ') + nextStatusName + '?' }}
                    </span>
                </div>
                <div class="d-flex align-center justify-space-around mt-5 mb-5">
                    <v-btn outlined color="primary" @click="changeStatusDialog = false">{{ $t('нет') }}</v-btn>
                    <v-btn color="primary" @click="changeStatus()">{{ $t('да') }}</v-btn>
                </div>
            </LabeledCard>
        </v-dialog>
    </div>
</template>

<script>
import translate from '@/utils/translate.util';
import { mapState, mapActions } from 'vuex';
import LabeledCard from '@/components/ui/LabeledCard.vue';

export default {
    name: 'Prescription',
    components: { LabeledCard },
    data: () => ({
        engineer_rid: null,
        contract_rid: null,
        isContract: true,
        ksk_rid: null,
        user_id: null,
        deleteDialog: false,
        selectedPresc: null,
        changeStatusDialog: false
    }),
    computed: {
        ...mapState('prescription', ['PrescriptionList', 'PrescriptionListLength', 'PrescriptionPagination', 'PrescriptionLoading', 'prescriptionStatusTypes']),
        ...mapState('users', ['userInfo']),
        ...mapState('permissions', ['userPermissions']),
        headers: function() {
            return [
                {
                    text: this.$t('№ п/п'),
                    sortable: false,
                    value: 'row_num'
                },
                {
                    text: this.$t('№ Договора'),
                    sortable: false,
                    value: 'contract_number'
                },
                {
                    text: this.$t('Наименование'),
                    sortable: false,
                    value: 'object_name'
                },
                {
                    text: this.$t('Адрес'),
                    sortable: false,
                    value: 'address_full_name'
                },
                {
                    text: this.$t('КСК'),
                    sortable: false,
                    value: 'ksk_name'
                },
                {
                    text: this.$t('№ предписания'),
                    sortable: false,
                    value: 'prescription_number'
                },
                {
                    text: this.$t('Дата выдачи'),
                    sortable: false,
                    value: 'issue_date'
                },
                {
                    text: this.$t('Период'),
                    sortable: false,
                    value: 'formed_period'
                },
                {
                    text: this.$t('Представитель ТОО «АлТС»'),
                    sortable: false,
                    value: 'engineer'
                },
                {
                    text: this.$t('Статус предписания'),
                    sortable: false,
                    value: 'status_name'
                },
                {
                    text: this.$t('Примечание'),
                    sortable: false,
                    value: 'note'
                },
                {
                    text: '',
                    sortable: false,
                    value: 'record_id'
                }
            ];
        },
        PLT() {
            return translate(this.PrescriptionList, 'full', this.$i18n.locale);
        },
        prescriptionPagination: {
            get() {
                return this.PrescriptionPagination;
            },
            async set(val) {
                this.$store.commit('prescription/setPrescriptionPagination', val);
                await this.loadTable();
            }
        },
        PSTT() {
            return translate(this.prescriptionStatusTypes, 'full', this.$i18n.locale);
        },
        nextStatusName() {
            if (!this.selectedPresc) return;
            if (this.selectedPresc.status_code_name === 'formed') return this.PSTT.find(x => x.status_code_name === 'issued').status_name;
            if (this.selectedPresc.status_code_name === 'issued') return this.PSTT.find(x => x.status_code_name === 'completed').status_name;
            else return '';
        }
    },
    methods: {
        ...mapActions('prescription', [
            'getPrescriptions',
            'getEventTypes',
            'postPrescriptions',
            'getEngineerKSKHousesList',
            'getEngineerObjectContractsList',
            'getEngineerContractsList',
            'GetPrescriptionStatusTypes',
            'prescriptionStatusChange'
        ]),
        ...mapActions('documents', ['getDocumentList', 'getRefAhsDocTypes', 'getUserContractsList', 'getUserObjectContractsList', 'getKSKHousesList']),
        ...mapActions('users', ['getUserInfo']),
        StatusChange(item) {
            this.changeStatusDialog = true;
            this.selectedPresc = item;
        },
        async changeStatus() {
            this.changeStatusDialog = false;
            let statusRid = null;
            if (this.selectedPresc.status_code_name === 'formed') statusRid = this.PSTT.find(x => x.status_code_name === 'issued').status_rid;
            if (this.selectedPresc.status_code_name === 'issued') statusRid = this.PSTT.find(x => x.status_code_name === 'completed').status_rid;
            await this.prescriptionStatusChange({ iPrescription_rid: this.selectedPresc.record_id, iStatus_rid: statusRid });
            this.loadTable();
        },
        openDeleteDialog(item) {
            this.deleteDialog = true;
            this.selectedPresc = item;
            //console.log(item);
        },
        async deletePresc() {
            //let data = {};
            //data.record_id = this.selectedPresc.record_id;
            //data.to_delete = 1;
            //await this.postPrescriptions({ nvcPrescriptionData: data });
            let statusRid = null;
            statusRid = this.PSTT.find(x => x.status_code_name === 'canceled').status_rid;
            await this.prescriptionStatusChange({ iPrescription_rid: this.selectedPresc.record_id, iStatus_rid: statusRid });
            await this.loadTable();
            this.deleteDialog = false;
        },
        async loadTable() {
            if (this.engineer_rid || this.contract_rid || this.ksk_rid || this.user_id) {
                await this.getPrescriptions({
                    engineer_rid: this.engineer_rid,
                    contract_rid: this.contract_rid,
                    ksk_rid: this.ksk_rid,
                    user_id: this.user_id,
                    itemsPerPage: this.prescriptionPagination.itemsPerPage,
                    currentItem: this.prescriptionPagination.itemsPerPage * (this.prescriptionPagination.page - 1)
                });
            }
        },
        async addPresc() {
            this.$router.push('/addprescription');
        },
        async openEdit(record_id) {
            this.$router.push('/editprescription/' + String(record_id));
        }
    },
    async created() {
        await this.getUserInfo();
        if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_ksk_rid) {
            this.ksk_rid = this.userInfo.user_data.isas_ksk_rid;
            this.isContract = false;
        } else if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_contract_rid) {
            this.contract_rid = this.userInfo.user_data.isas_contract_rid;
            this.isContract = true;
        }
        if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_engineer_rid) {
            this.engineer_rid = this.userInfo.user_data.isas_engineer_rid;
        }
        this.user_id = this.userInfo.record_id;

        //this.engineer_rid = 2;
        this.$store.commit('prescription/setiengineer_rid', this.engineer_rid);
        await this.loadTable();
        await this.GetPrescriptionStatusTypes();
        //console.log(this.userPermissions);
        //console.log(this.userPermissions.some(x => x === 'prescription_form'));
    }
};
</script>
